export enum TIPO_PERSONA {
  CLIENTE_TITULAR = 0,
  CLIENTE_INTEGRANTE = 1
}
